import React from 'react';
import { Redirect, Route, useLocation, useRouteMatch } from 'react-router-dom';
import RoleService from '../../services/utility/role';
import CorporateRegistration from './corporateRegistration/corporateRegistration.component';

// const roleService = new RoleService();

export default function CorporateRegisterRoutersComponent() {
  const { path } = useRouteMatch();
  const location = useLocation();

  //   const hasAccess = roleService.checkRouteAccess({ location });
  const hasAccess = true;

  return hasAccess ? (
    <Route exact path={path} component={CorporateRegistration} />
  ) : (
    <Redirect
      to={{
        pathname: '/unauthorized',
        state: { from: location },
      }}
    />
  );
}
